module.exports = __webpack_public_path__ + "img/glassquality_2.f47649d5.png";